import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=3a036e0e"
import script from "./slideshow.vue?vue&type=script&lang=js"
export * from "./slideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports